import '@babel/polyfill'

import CookiesModal from '@src/components/CookiesModal/CookiesModal'
import CookiesNotice from '@src/components/CookiesModal/dit.components.cookie-notice'

export default {
  CookiesModal,
  CookiesNotice
};
